// Function to customize arrows
function customizeInstaFeedArrows() {
  // SVG for previous arrow (pointing LEFT - flipped horizontally)
  const prevArrowSVG = `
    <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.3135 8.5L14.1699 16.6426L12.5332 14.9492L17.3896 10.0937L17.8164 9.66699L0.25 9.66699L0.25 7.33301L17.8164 7.33301L12.5332 2.0498L14.1699 0.356445L22.3135 8.5Z" fill="black" stroke="#FDFBF7" stroke-width="0.5"/>
    </svg>
  `;

  // SVG for next arrow (pointing RIGHT)
  const nextArrowSVG = `
    <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.3135 8.5L14.1699 16.6426L12.5332 14.9492L17.3896 10.0937L17.8164 9.66699L0.25 9.66699L0.25 7.33301L17.8164 7.33301L12.5332 2.0498L14.1699 0.356445L22.3135 8.5Z" fill="black" stroke="#FDFBF7" stroke-width="0.5"/>
    </svg>
  `;

  // Find the Instagram feed container
  const feedContainer = document.getElementById('insta-feed');
  if (!feedContainer) return;

  // Find arrow buttons within the feed container only
  const prevButtons = feedContainer.querySelectorAll('.instafeed-new-arrow-prev');
  const nextButtons = feedContainer.querySelectorAll('.instafeed-new-arrow-next');

  // Style for previous button (left arrow)
  const prevButtonStyle = `
    background: white !important;
    border: none !important;
    width: 45px !important;
    height: 45px !important;
    min-width: 45px !important;
    min-height: 45px !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    cursor: pointer !important;
    border-radius: 50% !important;
    margin-left: 20px !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
  `;

  // Style for next button (right arrow)
  const nextButtonStyle = `
    background: white !important;
    border: none !important;
    width: 45px !important;
    height: 45px !important;
    min-width: 45px !important;
    min-height: 45px !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    cursor: pointer !important;
    border-radius: 50% !important;
    margin-right: 20px !important;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1) !important;
  `;

  // Replace previous arrows
  prevButtons.forEach(button => {
    if (!button.dataset.customized) {
      button.innerHTML = prevArrowSVG;
      button.style.cssText = prevButtonStyle;
      button.dataset.customized = 'true';
    }
  });

  // Replace next arrows
  nextButtons.forEach(button => {
    if (!button.dataset.customized) {
      button.innerHTML = nextArrowSVG;
      button.style.cssText = nextButtonStyle;
      button.dataset.customized = 'true';
    }
  });
}

// Run when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', customizeInstaFeedArrows);
} else {
  customizeInstaFeedArrows();
}

// Delayed execution for Instagram feed initialization
setTimeout(customizeInstaFeedArrows, 500);
setTimeout(customizeInstaFeedArrows, 1500);

// Optional: Observe only the Instagram feed container
const feedContainer = document.getElementById('insta-feed');
if (feedContainer) {
  const observer = new MutationObserver(function(mutations) {
    // Only customize if arrows were added/modified
    const hasArrowChanges = mutations.some(mutation => {
      return Array.from(mutation.addedNodes).some(node => {
        return node.nodeType === 1 && 
               (node.classList?.contains('instafeed-new-arrow') || 
                node.querySelector?.('.instafeed-new-arrow'));
      });
    });
    
    if (hasArrowChanges) {
      customizeInstaFeedArrows();
    }
  });

  // Observe only the feed container
  observer.observe(feedContainer, {
    childList: true,
    subtree: true
  });
}